import { useQuery } from "@tanstack/react-query";
import type { AccountType } from "@shared/schema";
import { useBetaAccessKeys } from "./use-beta-access";
import { useFeatureGates } from "./use-feature-gates";
import { usePermissions } from "./use-permissions";
import { isHomeCardVisible } from "@/lib/home-card-visibility";

export function useHomeCardVisibility() {
  const betaKeys = useBetaAccessKeys();
  const featureGates = useFeatureGates();
  const permissions = usePermissions();
  const tierLocks = useQuery<{ deniedKeys?: string[] }>({
    queryKey: ["/api/app/menu-tier-locks/denied"],
    staleTime: 60_000,
  });
  const auth = useQuery<{
    user: { selectedPlan?: AccountType; accountKind?: string | null };
    effectivePlan?: AccountType;
  }>({ queryKey: ["/api/app/auth/me"] });

  return (href: string) => isHomeCardVisible(href, {
    loaded: featureGates.loaded && !featureGates.failed && tierLocks.isSuccess && auth.isSuccess && !!auth.data?.user && !permissions.isLoading,
    betaKeys,
    gates: featureGates.byKey,
    deniedKeys: tierLocks.data?.deniedKeys ?? [],
    canView: permissions.canView,
    plan: auth.data?.effectivePlan ?? auth.data?.user?.selectedPlan ?? "Interest",
    modular: auth.data?.user?.accountKind != null,
  });
}